<template>
    <div>
        <div class="payment-top" v-if="!isMobile">
            <div class="buttons">
                <button :class="user_router == 'deposit' ? 'primary' : 'secondary' " class="button" @click="changeSystem('deposit')">Para Yatır</button>
                <button :class="user_router == 'withdraw' ? 'primary' : 'secondary' " class="button" @click="changeSystem('withdraw')">Para Çek</button>
            </div>
            <div class="search">
                <input type="text" placeholder="Arama Yapın" @keyup="filter($event)">
            </div>
        </div>
        <div class="mobile-nav-menu" v-if="isMobile">
            <ul>
                <li><a :class="user_router == 'deposit' ? 'active' : '' " href="javascript:;" @click="changeSystem('deposit')">Para Yatırımı</a></li>
                <li><a :class="user_router == 'withdraw' ? 'active' : '' " href="javascript:;" @click="changeSystem('withdraw')">Para Çekimi</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default{
        computed:{
            user_router(){
                return this.$store.getters.getUserRouter;
            }
        },
        methods:{
          changeSystem(system){
            this.$store.commit('setUserRouter', system);
            if(this.$route.params.section){
                this.$router.push({ name: 'User', params: { section: system, payment: null } })
            }
          },
          filter(event){
              this.$emit('filter', event.target.value);
          }
        }
    }
</script>